import { normalizeValue } from '@dte/otw-utils-core/src/strings/normalizeValue';

function addSearchParam(searchParams: URLSearchParams, key: string, value: string): URLSearchParams {
	const newSearchParams = new URLSearchParams(searchParams);

	// TODO: should we be using lowercase everywhere for keys?
	const normalizedKey = normalizeValue(key);
	if (!normalizedKey) {
		return newSearchParams;
	}

	const normalizedValue = normalizeValue(value);
	if (normalizedValue) {
		newSearchParams.set(normalizedKey, normalizedValue);
	} else {
		newSearchParams.delete(normalizedKey);
	}

	return newSearchParams;
}

const dummyDomain = 'http://example.com';

export function addSearchParamsToUrl(
	originalUrl: string | undefined,
	params: Record<string, string> = {},
): string | undefined {
	// No URL to modify
	const normalized = normalizeValue(originalUrl);
	if (!normalized) {
		return undefined;
	}

	// Nothing to add
	if (!params) {
		return originalUrl;
	}

	// TODO: need to better handle this

	// Treat as a relative url if it doesn't have a scheme
	const relativeUrl = !normalized.startsWith('http');

	let url: URL;
	try {
		if (relativeUrl) {
			// Handle relative URLs by providing a base URL
			url = new URL(normalized, dummyDomain);
		} else {
			url = new URL(normalized);
		}
	} catch {
		return undefined;
	}

	// Include existing parameters
	let searchParams = new URLSearchParams(url.search);

	// Append new parameters to existing ones
	for (const [key, value] of Object.entries(params)) {
		searchParams = addSearchParam(searchParams, key, value);
	}

	// Set the updated search parameters back to the URL object
	url.search = searchParams.toString();

	// Return the pathname and search part of the URL to handle relative URLs correctly

	let updatedUrl = url.toString();
	if (relativeUrl) {
		updatedUrl = updatedUrl.substring(dummyDomain.length);
	}

	return updatedUrl;
}

export function addSearchParamToUrl(originalUrl: string | undefined, key: string, value: string): string | undefined {
	return addSearchParamsToUrl(originalUrl, { [key]: value });
}
